import React, { Component } from "react";
import swal from "sweetalert";
import { withNamespaces } from "react-i18next";
import "../../Comman/assets/css/toggleSlider.css";
class AlarmRulesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowIndex: null,
      isEditable: false,
      alarmRuleName: "",
      alarmRuleValue: 1,
      RegionId: "",
      IsLifeguardPerformedCPR: false,
      IsLifeGuardUseDefibrillator: false,
      EditIsLifeguardPerformedCPR: false,
      EditIsLifeGuardUseDefibrillator: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    console.log("next", nextProps);
    if (
      nextProps.getAlarmRules.updatedList !=
      this.props.getAlarmRules.updatedList
    ) {
      if (nextProps.getAlarmRules.statusCode == 200) {
        swal(nextProps.getAlarmRules.message, {
          icon: "success",
        });
        this.setState({ rowIndex: null, isEditable: false });
        this.props.getAllRules();
      }
    }
    /* if (
      nextProps.getAlarmRules.lifeguardPerformedDefibrillator !=
      this.props.getAlarmRules.lifeguardPerformedDefibrillator
    ) {
      if (nextProps.getAlarmRules.statusCode == 200) {
        swal(nextProps.getAlarmRules.message, {
          icon: "success",
        });
        //this.setState({ rowIndex : null, isEditable : false})
        this.props.getlifeguardPerformedDefibrillator();
      }
    } */
    if (nextProps.getAlarmRules.lifeguardPerformedDefibrillator != this.props.getAlarmRules.lifeguardPerformedDefibrillator) {
       
      this.setState({
        IsLifeguardPerformedCPR:
          nextProps.getAlarmRules.lifeguardPerformedDefibrillator
            .IsLifeguardPerformedCPR,
        IsLifeGuardUseDefibrillator:
         nextProps.getAlarmRules.lifeguardPerformedDefibrillator
            .IsLifeGuardUseDefibrillator,
      });
    }
  }
  
  handleChange = (event) => {
    this.setState({
      alarmRuleValue: event.target.value,
    });
  };
  edit = (data) => {
    console.log("item", data);
    this.setState({
      rowIndex: data.index,
      isEditable: true,
      alarmRuleName: data.AlarmRuleName,
      alarmRuleValue: data.AlarmRuleValue,
    });
  };
  save = () => {
    const { t } = this.props;
    if (this.state.alarmRuleValue > 0) {
      let data = {
        AlarmRuleName: this.state.alarmRuleName,
        AlarmRuleValue: this.state.alarmRuleValue,
        RegionId:
          this.state.RegionId == ""
            ? this.props.getAlarmRules.regionList.length > 0
              ? this.props.getAlarmRules.regionList[0].ID
              : null
            : this.state.RegionId,
      };

      this.props.updateRule(data);
    } else {
      swal(`${t("Alarm Setting.Please enter value greater than 0")}`);
    }
  };

  handleIsLifeguardPerformedCPR = (event) => {
    this.setState(
      {
        IsLifeguardPerformedCPR: !this.state.IsLifeguardPerformedCPR,
      },
      () => {
        let data = {
          IsLifeguardPerformedCPR: this.state.IsLifeguardPerformedCPR,
          IsLifeGuardUseDefibrillator: this.state.IsLifeGuardUseDefibrillator,
          RegionId:
            this.state.RegionId == ""
              ? this.props.getAlarmRules.regionList.length > 0
                ? this.props.getAlarmRules.regionList[0].ID
                : null
              : this.state.RegionId,
        };

        this.props.updatelifeguardPerformedDefibrillator(data);
      }
    );
  };

  handleIsLifeGuardUseDefibrillator = (event) => {
    this.setState(
      {
        IsLifeGuardUseDefibrillator: !this.state.IsLifeGuardUseDefibrillator,
      },
      () => {
        let payload = {
          IsLifeGuardUseDefibrillator: this.state.IsLifeGuardUseDefibrillator,
          IsLifeguardPerformedCPR: this.state.IsLifeguardPerformedCPR,
          RegionId:
            this.state.RegionId == ""
              ? this.props.getAlarmRules.regionList.length > 0
                ? this.props.getAlarmRules.regionList[0].ID
                : null
              : this.state.RegionId,
        };
        this.props.updatelifeguardPerformedDefibrillator(payload);
      }
    );
  };

  cancel = () => {
    this.setState({
      rowIndex: null,
      isEditable: false,
      alarmRuleName: "",
      alarmRuleValue: 0,
    });
  };
  cancelEditIsLifeguardPerformedCPR = () => {
    this.setState({
      EditIsLifeguardPerformedCPR: false,
    });
  };
  changeRegion = (e) => {
    let value = e.target.value;
    let payload = {
      RegionId: value,
    };
    this.state.RegionId = value.toString();
    this.setState({ RegionId: value.toString() });

  this.props.getUserList(payload)

    // sleep(3000).then(() => {
    //     console.log("setstate",this.state);
    // })
  };
  render() {
    const { t } = this.props;
    let regionListOption;
    let regionList = this.props.getAlarmRules.regionList;
    if (regionList) {
      regionListOption = regionList.map((item) => (
        <option style={{ background: "#f5f1f1" }} value={item.ID} key={item.ID}>
          {item.RegionName}
        </option>
      ));
    }
    console.log("props", this.props.getAlarmRules);
    return (
      <div className="container">
        <div className="progressbar-heading grids-heading">
          <h2>{t("Alarm Setting.Alarm Rules")}</h2>
        </div>

        <div className="panel panel-widget forms-panel w3-last-form setting-layout">
          <div className="text-left m-b-25 ">
            <select
              id="regionData"
              style={{ fontSize: "large", padding: "7px" }}
              onChange={this.changeRegion}
              placeholder="Select"
              ref="regionData"
              name={"RegionId"}
            >
              {regionListOption}
            </select>
          </div>
         
          <div className="setting-data" style={{ marginTop: "40px" }}>
             <div className="row contact-data">
              <div className="col-md-6">
                <div className="displaynone"></div>
                <p className="displaynone">
                  {(this.state.EditIsLifeguardPerformedCPR = false)}
                </p>
                <p>Lifeguard Performed CPR</p>
              </div>
              <div className="col-md-3">
                <div
                  className="toggle-container"
                  onClick={this.handleIsLifeguardPerformedCPR}
                >
                  <div
                    className={`slider ${
                      this.state.IsLifeguardPerformedCPR ? "on" : "off"
                    }`}
                  >
                    <div className="circle"></div>
                  </div>
             
                </div>
              </div>
             <div className="col-md-3">
                <p style={{marginTop:'6px'}}>{this.state.IsLifeguardPerformedCPR ? "ON" : "OFF"}</p>
              </div>
            </div>
            <div className="row contact-data">
              <div className="col-md-6">
                <div className="displaynone"></div>
                <p className="displaynone">
                  {(this.state.EditIsLifeGuardUseDefibrillator = false)}
                </p>
                <p>Lifeguard Use Defibrillator</p>
              </div>
              <div className="col-md-3">
                <div
                  className="toggle-container"
                  onClick={this.handleIsLifeGuardUseDefibrillator}
                >
                  <div
                    className={`slider ${
                      this.state.IsLifeGuardUseDefibrillator ? "on" : "off"
                    }`}
                  >
                    <div className="circle"></div>
                  </div>
                 
                </div>
              </div>
        <div className="col-md-3">
                <p style={{marginTop:'6px'}}>{this.state.IsLifeGuardUseDefibrillator ? "ON" : "OFF"}</p>
              </div>
            </div>
            {this.props.getAlarmRules &&
            this.props.getAlarmRules.alarmRules.length ? (
              this.props.getAlarmRules.alarmRules.map((item, index) => (
                <div key={index} id={index} className="row contact-data">
                  <div className="col-md-6">
                    <div className="displaynone">{(item.index = index)}</div>
                    <p className="displaynone">{(item.isEdit = false)}</p>
                    <p>{item.AlarmRuleDescription}</p>
                  </div>
                  <div className="col-md-3">
                    {this.state.rowIndex == item.index ? (
                      <input
                        type="number"
                        value={this.state.alarmRuleValue}
                        onChange={this.handleChange}
                      />
                    ) : (
                      <p>{item.AlarmRuleValue}</p>
                    )}
                  </div>
                  <div className="col-md-3">
                    {this.state.rowIndex == item.index ? (
                      <div>
                        <button
                          type="button"
                          className="btn btn-primary mar-right-15"
                          onClick={this.save}
                        >
                          {t("Alarm Setting.Save")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={this.cancel}
                        >
                          {t("Alarm Setting.Cancel")}
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={this.edit.bind(this, item)}
                        className={
                          this.state.isEditable == item.isEdit
                            ? "btn btn-primary"
                            : "btn btn-primary not-show-btn"
                        }
                      >
                        {t("Alarm Setting.Edit")}
                      </button>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p>{t("Alarm Setting.No alarm rules")}</p>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(AlarmRulesComponent);
